import { IBimehNamehDto } from 'Feature/Mosaferati/Common/types/Commands/Sodoor/IBimehNamehDto';

export const BimehNamehInitialState: IBimehNamehDto = {
  sen: 0,
  moddatSafar: 0,
  countryCoreId: undefined,
  mohlatBazdid: null, // مهلت بازدید نداریم
  tarhSafarCoreId: undefined,
};
